export { HomeIcon } from "./home";
export { PersonIcon } from "./person";
export { ArchiveIcon } from "./archive";
export { CodeIcon } from "./code";
export { IdCardIcon } from "./idcard";
